import Vue from 'vue';
import Empty from './Empty.vue'

export default {
  install(Vue) {

    Vue.component(Empty.name, Empty);
  }
}
